//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.EntityPropTableBuilder.js";
let d=[[],[],[]];
SPLM.Motion.ContactPatternBuilder = class extends SPLM.Motion.EntityPropTableBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.ContactPatternBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.ContactPatternBuilder.StepTypes = Object.freeze({
    "Time" : "Time", "Steps" : "Steps"});

SPLM.Motion.ContactPatternBuilder.Component = Object.freeze({
    "NormalForce" : "NormalForce", "NormalForceX" : "NormalForceX", "NormalForceY" : "NormalForceY", "NormalForceZ" : "NormalForceZ", "TangentialForce" : "TangentialForce", "TangentialForceX" : "TangentialForceX", "TangentialForceY" : "TangentialForceY", "TangentialForceZ" : "TangentialForceZ", "Fx" : "Fx", "Fy" : "Fy", "Fz" : "Fz", "ForceMagnitude" : "ForceMagnitude"});

SPLM.Motion.ContactPatternBuilder.TriangulationMethod = Object.freeze({
    "Delaunay" : "Delaunay", "Simple" : "Simple"});

export default SPLM;